var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Fab from '@mui/material/Fab';
import React, { forwardRef } from 'react';
const FabButton = forwardRef((props, ref) => {
    const { children, active, onClick, endIcon: _endIcon } = props, rest = __rest(props, ["children", "active", "onClick", "endIcon"]);
    return (React.createElement(Fab, Object.assign({ ref: ref, onClick: onClick, sx: (theme) => (Object.assign({ bgcolor: 'background.paper', 'path, circle': {
                fill: theme.palette.text.secondary,
            }, '&:hover, &.active': {
                bgcolor: 'background.default',
            }, '&.Mui-disabled': {
                bgcolor: 'background.paper',
            } }, (active && {
            bgcolor: 'background.paper',
            'path, circle': {
                fill: theme.palette.primary.main,
            },
        }))) }, rest), children));
});
FabButton.displayName = 'FabButton';
export default FabButton;
